import { useGlobalContext } from '@/components/Context/hooks/useGlobalContext';
import { LiquidButton } from '@/components/LiquidButton';
import { NextLink } from '@/components/NextLink';
import { TrackingService } from '@/service/tracking/trackingService';
import { COLORS } from '@/styles/constants';
import { useHits } from 'react-instantsearch';

export const QuerySuggestionsItem = ({ onClick, searchBoxRef, searchData, ...props }: any) => {
  const { pathTranslations } = useGlobalContext();
  const searchUrl = pathTranslations?.search;
  const { items, results } = useHits(props);
  const query = results?.query ? `?query=${results?.query}` : '';

  return (
    !!items.length &&
    results?.query && (
      <div data-test="card-carousel-cta-button-wrapper" className="text-center">
        <NextLink
          href={`${searchUrl || '/search'}${query}`}
          onClick={() => {
            TrackingService.clickSearchAllSuggestions &&
              TrackingService.clickSearchAllSuggestions(searchBoxRef, items.length);
            onClick && onClick();
          }}
          target="_self"
          rel="noreferrer"
        >
          <LiquidButton
            data-test="card-carousel-cta-button"
            text={`${searchData?.linkText} ${items.length > 4 ? `(${items.length})` : ''}`}
            height={58}
            width={250}
            color={COLORS.primary}
            textColor={COLORS.white}
            isWidthAuto
          />
        </NextLink>
      </div>
    )
  );
};
